import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import './index.css';

const Lead = () => {
  const { id } = useParams();  // Get the lead ID from the URL
  const [lead, setLead] = useState({
    company: '',
    name: '',
    email: '',
    phone: '',
    whatsapp: '',
    address: '',
    source: '',
    status: 'open', // fixed value
  });

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const fetchLeadData = async () => {
        try {
          const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/leads/${id}`);
          const data = await response.json();
          if (response.ok && data) {
            setLead({
              company: data.company || '',
              name: data.name || '',
              email: data.email || '',
              phone: data.phone || '',
              whatsapp: data.whatsapp || '',
              address: data.address || '',
              source: data.source || '',
              leadby: data.leadby || '',
              remarks: data.remarks || '',
              status: data.status || 'open',
            });
            console.log(data);
          } else {
            setErrorMessage('Lead not found or failed to fetch data.');
          }
        } catch (error) {
          setErrorMessage('Error fetching lead data');
        } finally {
          setLoading(false);
        }
      };

      fetchLeadData();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLead(prevLead => ({
      ...prevLead,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');
    setLoading(true);

    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/update_lead/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...lead, leadBy: id }),
      });

      const data = await response.json();
      console.log('Response from API:', data);
      if (response.ok) {
        setSuccessMessage('Lead successfully updated!');
      } else {
        setErrorMessage(data.error || 'An error occurred');
      }
    } catch (error) {
      setErrorMessage('There was an error submitting the lead. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="container mt-5">
        {successMessage && <div className="alert alert-success">{successMessage}</div>}
        {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

        <div className="card shadow">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h2>Edit Lead</h2>
             <button className="btn btn-primary" onClick={() => navigate('/Leadlist')}> Lead List </button>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3 d-none">
                  <label htmlFor="company" className="form-label">Company / Business Name</label>
                  <input type="text" className="form-control" id="company" name="company" value={lead.company} onChange={handleChange}  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="name" className="form-label">Name</label>
                  <input type="text" className="form-control" id="name" name="name" value={lead.name} onChange={handleChange} required />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input type="email" className="form-control" id="email" name="email" value={lead.email} onChange={handleChange} required />
                </div>
              </div>

              <div className="row">
                
                <div className="col-md-6 mb-3">
                  <label htmlFor="phone" className="form-label">Phone</label>
                  <input type="tel" className="form-control" id="phone" name="phone" value={lead.phone} onChange={handleChange} required />
                </div>
                
                <div className="col-md-6 mb-3 d-none">
                  <label htmlFor="whatsapp" className="form-label">WhatsApp</label>
                  <input type="tel" className="form-control" id="whatsapp" name="whatsapp" value={lead.whatsapp} onChange={handleChange} />
                </div>

                 <div className="col-md-6 mb-3">
                  <label htmlFor="source" className="form-label">Source</label>
                  <input type="text" className="form-control" id="source" name="source" value={lead.source} onChange={handleChange} required />
                </div>
              </div>

              <div className="row d-none">
                <div className="col-md-6 mb-3 d-none">
                  <label htmlFor="address" className="form-label">Address</label>
                  <input type="text" className="form-control" id="address" name="address" value={lead.address} onChange={handleChange} />
                </div>
              </div>

              <div className="row">

                <div className="col-md-6 mb-3 ">
                  <label htmlFor="leadBy" className="form-label">Lead By</label>
                  <input type="text" className="form-control" id="leadby" name="leadby" value={lead.leadby} onChange={handleChange}  />
                </div>

                <div className="col-md-6 mb-3 ">
                  <label htmlFor="remarks" className="form-label">Remarks</label>
                 
                  <textarea className="form-control" id="remarks" name="remarks" value={lead.remarks}  onChange={handleChange} ></textarea>
                </div>
               
              </div>
              
              <div className="row">
                 <div className="col-md-6 mb-3">
                  <label htmlFor="status" className="form-label">Status</label>
                  <select className="form-select" id="status" name="status" value={lead.status} onChange={handleChange}  required>
                    <option value="open">Open</option>
                     <option value="in-progress">In Progress</option>
                  </select>
                </div>
                
              </div>

              <center>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </center>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Lead;
